import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1)
const _hoisted_2 = { class: "flex items-center justify-end mt-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-link mr-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_alert = _resolveComponent("alert")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["StepUpdate", { 'flex items-center justify-end': !_ctx.updated }])
  }, [
    (!_ctx.updated)
      ? (_openBlock(), _createBlock(_component_the_button, {
          key: 0,
          class: "primary small",
          loading: _ctx.loading,
          onClick: _ctx.emitSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_1,
            _createTextVNode(" Отредактировать заказ ")
          ]),
          _: 1
        }, 8, ["loading", "onClick"]))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_alert, { class: "w-full text-center success" }, {
            default: _withCtx(() => [
              _createTextVNode(" Заказ успешно отредактирован! ")
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_router_link, {
              to: `/order/${_ctx.orderId}`
            }, {
              default: _withCtx(() => [
                _createVNode(_component_the_button, { class: "primary small mr-3" }, {
                  default: _withCtx(() => [
                    _hoisted_3,
                    _createTextVNode(" Перейти к заказу ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_the_button, {
              class: "primary small",
              onClick: _ctx.emitUpdateOrder
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _createTextVNode(" Отредактировать заказ ещё раз ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ])
        ], 64))
  ], 2))
}